var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.searchable)?_c('div',{staticClass:"flex",class:[_vm.marginBottom]},[_c('input',{staticClass:"w-full shadow p-2",class:[_vm.cssRadius],style:({backgroundColor:_vm.searchInputColor}),attrs:{"type":"text","placeholder":"Suchen..."},domProps:{"value":_vm.value},on:{"input":_vm.emitValue}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }